(() => {
  const BADGE_SELECTOR = '.orkide-count-badge, .mobile-bottom-nav__badge, .mobile-bottom-nav__badge--wishlist';
  const COLLECTION_PANEL_SELECTOR = '[data-orkide-collection-panel]';
  const COLLECTION_GRID_SELECTOR = '[data-orkide-collection-grid]';
  const COLLECTION_VIEW_BUTTON_SELECTOR = '[data-orkide-view-columns]';
  const COLLECTION_VIEW_STORAGE_KEY = 'orkideCollectionView';
  const badgeState = new WeakMap();

  const clampBadgeValue = (value) => {
    const parsed = Number.parseInt(String(value || '').replace(/[^\d]/g, ''), 10);
    if (Number.isNaN(parsed) || parsed < 0) return 0;
    return parsed;
  };

  const formatBadgeValue = (value) => {
    if (value <= 0) return '';
    return value > 99 ? '99' : String(value);
  };

  const pulseBadge = (badge) => {
    badge.classList.remove('is-updated');
    void badge.offsetWidth;
    badge.classList.add('is-updated');
    window.setTimeout(() => {
      badge.classList.remove('is-updated');
    }, 220);
  };

  const syncBadge = (badge) => {
    const currentValue = clampBadgeValue(
      badge.dataset.countValue || badge.getAttribute('data-count-value') || badge.textContent
    );
    const previousValue = badgeState.get(badge);

    badge.dataset.countValue = String(currentValue);

    if (!badge.matches('[data-wishlist-count]')) {
      const nextText = formatBadgeValue(currentValue);
      if (nextText !== badge.textContent.trim()) {
        badge.textContent = nextText;
      }
    }

    badge.classList.toggle('is-hidden', currentValue <= 0);
    badge.classList.toggle('is-empty', currentValue <= 0);

    if (typeof previousValue === 'number' && previousValue !== currentValue) {
      pulseBadge(badge);
    }

    badgeState.set(badge, currentValue);
  };

  const syncAllBadges = (root = document) => {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(BADGE_SELECTOR).forEach(syncBadge);
  };

  const normalizeCollectionView = (value, fallback = '2') => {
    const nextValue = String(value || '').trim();
    return ['1', '2', '3'].includes(nextValue) ? nextValue : String(fallback || '2');
  };

  const readCollectionView = (fallback = '2') => {
    try {
      return normalizeCollectionView(window.localStorage.getItem(COLLECTION_VIEW_STORAGE_KEY), fallback);
    } catch (_error) {
      return normalizeCollectionView(fallback, '2');
    }
  };

  const writeCollectionView = (value) => {
    try {
      window.localStorage.setItem(COLLECTION_VIEW_STORAGE_KEY, normalizeCollectionView(value));
    } catch (_error) {
      // Keep the selected view in the current DOM state even if storage is unavailable.
    }
  };

  const applyCollectionView = (root = document) => {
    const scope = root && root.querySelectorAll ? root : document;
    const panels = scope.matches && scope.matches(COLLECTION_PANEL_SELECTOR)
      ? [scope]
      : Array.from(scope.querySelectorAll(COLLECTION_PANEL_SELECTOR));

    panels.forEach((panel) => {
      const grid = panel.querySelector(COLLECTION_GRID_SELECTOR);
      if (!grid) return;

      const fallbackView = normalizeCollectionView(grid.dataset.defaultView || '2', '2');
      const selectedView = readCollectionView(fallbackView);

      grid.dataset.viewColumns = selectedView;

      panel.querySelectorAll(COLLECTION_VIEW_BUTTON_SELECTOR).forEach((button) => {
        const isActive = normalizeCollectionView(button.dataset.orkideViewColumns, fallbackView) === selectedView;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    });
  };

  document.addEventListener('DOMContentLoaded', () => syncAllBadges(document));
  document.addEventListener('shopify:section:load', (event) => syncAllBadges(event.target));
  document.addEventListener('shopify:section:reorder', () => syncAllBadges(document));

  document.addEventListener('DOMContentLoaded', () => applyCollectionView(document));
  document.addEventListener('shopify:section:load', (event) => applyCollectionView(event.target));
  document.addEventListener('shopify:section:reorder', () => applyCollectionView(document));
  document.addEventListener('orkide:collection-grid-rendered', () => applyCollectionView(document));

  document.addEventListener(
    'click',
    (event) => {
      const trigger = event.target.closest(COLLECTION_VIEW_BUTTON_SELECTOR);
      if (!trigger) return;

      const panel = trigger.closest(COLLECTION_PANEL_SELECTOR);
      if (!panel) return;

      event.preventDefault();
      writeCollectionView(trigger.dataset.orkideViewColumns);
      applyCollectionView(panel);
    },
    true
  );
})();
